import {Component, Input} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {SubtitlesService} from "../../../core";

@Component({
  selector: 'form-password-input',
  standalone: true,
    imports: [
        NgOptimizedImage,
        ReactiveFormsModule,
        NgClass
    ],
  templateUrl: './form-password-input.component.html',
  styleUrl: './form-password-input.component.scss'
})
export class FormPasswordInputComponent {
    @Input({ required: true }) inputControl!: FormControl;
    @Input({ required: true }) placeholder!: string;
    @Input({ required: true }) id!: string;
    @Input() showPasswordMismatch: boolean = false;
    showPassword = false;

    constructor(public subtitles: SubtitlesService) {
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    isInvalid(): boolean {
        return this.inputControl?.invalid && (this.inputControl?.dirty || this.inputControl?.touched);
    }
}
